/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosTrxListRequest = {
    trxType?: AptosTrxListRequest.trxType;
    page?: number;
    size?: number;
};

export namespace AptosTrxListRequest {

    export enum trxType {
        ALL = 'all',
        GENESIS_TRANSACTION = 'genesis_transaction',
        BLOCK_METADATA_TRANSACTION = 'block_metadata_transaction',
        USER_TRANSACTION = 'user_transaction',
        STATE_CHECKPOINT_TRANSACTION = 'state_checkpoint_transaction',
        VALIDATOR_TRANSACTION = 'validator_transaction',
        PENDING_TRANSACTION = 'pending_transaction',
        BLOCK_EPILOGUE_TRANSACTION = 'block_epilogue_transaction',
    }


}

